(function () {
  /**
   * @ngdoc module
   * @name binky.core.src2-migration
   * @description module that defines react related modules
   */
  angular.module('binky.core.src2-migration', []);
})();
